<template>
    <section class="content">
        <FormGroup label="お支払い方法の選択" name="payment_type"
                type="select" :options="paymentTypes"
                v-model="request.payment_type" :errors="errors" required/>
        <div v-if="request.payment_type === 'credit'">
            <FormGroup v-model="payment.credit.cardno"
                    :errors="errors" input-class="w-80 max-w-full"
                    autocomplete="cc-number"
                    name="cardno" label="カード番号" maxlength="19"/>
            <BrandLogos/>
            <div class="form-group">
                <FormLabel>有効期限</FormLabel>
                <CardExpireInput v-model="payment.credit.expire"/>
            </div>
            <FormGroup v-model="payment.credit.securitycode"
                    :errors="errors"
                    input-class="w-48"
                    autocomplete="cc-csc"
                    name="securitycode" label="セキュリティコード" maxlength="4"/>
            <SecurityCodeInformation/>
            <div class="form-group">
                <FormLabel>お支払い回数</FormLabel>
                <FormInput type="select" class="w-48"
                        v-model="request.pay_times"
                        :options="payTimesList"/>
                <ErrorText :errors="errors" name="pay_times"/>
            </div>
        </div>
        <div v-show="request.payment_type === 'stripe'">
            <div class="mx-2">
                <div id="payment-element" ref="paymentElement"></div>
                <p v-if="cardError" style="color:#c00;margin-top:8px;">{{ cardError }}</p>
            </div>
        </div>
        <div v-if="request.payment_type === 'apple_pay' || request.payment_type === 'google_pay'" class="wallet-info pl-4">
            <p>{{ request.payment_type === 'apple_pay' ? 'Apple Pay' : 'Google Pay' }} をご利用いただけるスピーディーな決済方法です。お使いのデバイスやブラウザに応じて、利用可能な決済方法が自動的に表示されます。</p>
        </div>
    </section>
</template>

<script>
import FormGroup from "../kyuseiki/FormGroup";
import FormLabel from "../kyuseiki/FormLabel";
import FormInput from "./FormInput";
import ErrorText from "../ErrorText";
import BrandLogos from "./BrandLogos";
import CardExpireInput from "./CardExpireInput";
import SecurityCodeInformation from "./SecurityCodeInformation";

export default {
    name: "PaymentForm",
    components: {
        FormGroup,
        FormLabel,
        FormInput,
        ErrorText,
        BrandLogos,
        CardExpireInput,
        SecurityCodeInformation,
    },
    props: {
        request: {
            type: Object,
        },
        payment: {
            type: Object,
        },
        errors: {
            type: Object,
        },
        cardError: {
            type: String,
            default: '',
        },
    },
    computed: {
        paymentTypes() {
            return [
                { value: 'stripe',     label: 'クレジットカード' },
                { value: 'apple_pay',  label: 'Apple Pay' },
                { value: 'google_pay', label: 'Google Pay' },
            ];
        },
        payTimesList() {
            return [
                { value: 1,       label: '1回' },
                { value: 'bonus', label: 'ボーナス払' },
            ];
        },
    },
}
</script>
